import React from "react";
import PropTypes from "prop-types";

import { Form } from "../DependencyHelper";
import styles from "./Checkbox.module.scss";

const CheckBoxGroup = ({ label, onChange, checked, id, name }) => {
  return (
    <Form.Group className={styles["checkbox-group"]}>
      <Form.Check
        custom
        className={`${styles["form-checkbox-label"]}`}
        id={id}
        onChange={onChange}
        checked={checked}
      >
        <Form.Check.Input
          name={name}
          type="checkbox"
          checked={checked}
          onChange={onChange}
        />
        <Form.Check.Label id={id}>
          <span dangerouslySetInnerHTML={{ __html: label }} />
        </Form.Check.Label>
      </Form.Check>
    </Form.Group>
  );
};

CheckBoxGroup.propTypes = {
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  checked: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
};

export default CheckBoxGroup;
